/**
 * Created by Vladislav on 07.03.2025.
 */

// value: { type, amount }
Reward.register("cup", {
    icon: {},
    smallIcon: {},
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    getIcon: function (value) {
        return this.icon[value.type];
    },

    getSmallIcon: function (value) {
        return this.smallIcon[value.type];
    },

    getTarget: function (value) {
        return `cup${value.type}`;
    },

    receive: function (value) {
        let cup;

        // a type the game does not run is undefined here and matches nothing
        switch (value.type) {
            case CupsConfig.TYPE_DAILY: cup = cleverapps.dailyCup; break;
            case CupsConfig.TYPE_WEEKLY: cup = cleverapps.weeklyCup; break;
            case CupsConfig.TYPE_CLAN: cup = cleverapps.clanCup; break;
        }

        if (cup) {
            cup.addAmount(value.amount);

            if (cup.innerCup) {
                cup.innerCup.addAmount(value.amount);
            }
        }

        return function () {};
    }
});
